module.exports = __webpack_public_path__ + "static/media/holidays.382e267d.webp";